'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LogoutModal;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Modal = require('../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _components = require('../../styled/components');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function LogoutModal(props) {
  return _react2.default.createElement(_Modal2.default, {
    title: 'Confirm sign out',
    config: {
      className: 'react-modal-container_w520',
      isOpen: props.isOpen,
      shouldCloseOnOverlayClick: true,
      onRequestClose: function onRequestClose() {
        props.onCancel();
      }
    },
    footer: _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_components.ThemedButtonCancel, {
      onClick: function onClick() {
        props.onCancel();
      }
    }, 'Cancel'), _react2.default.createElement(_components.ThemedButton, {
      type: 'primary',
      onClick: function onClick() {
        props.onSignOut();
      }
    }, 'Sign out'))
  }, _react2.default.createElement('p', null, 'Are you sure you want to sign out of your account?'));
}